const deletePersonalDataCheckbox = document.getElementById(
  'request_type_Deletion of Personal Information',
) as HTMLInputElement;
const deletePersonalDataFollowUp = document.getElementById(
  'deletion-follow-up',
) as HTMLElement;
const revokeConsentCheckbox = document.getElementById(
  'request_type_Revocation of Consent',
) as HTMLInputElement;
const revokeConsentFollowUp = document.getElementById(
  'revocation-follow-up',
) as HTMLElement;

const showHidePersonalDataFollowUp = async () => {
  const radioButtons =
    deletePersonalDataFollowUp?.querySelectorAll<HTMLInputElement>(
      'input[type="radio"]',
    );
  if (deletePersonalDataCheckbox?.checked) {
    deletePersonalDataFollowUp?.classList.remove('d-none');
    radioButtons?.forEach((radioButton) => {
      radioButton.setAttribute('required', 'true');
    });
  } else {
    deletePersonalDataFollowUp?.classList.add('d-none');
    radioButtons?.forEach((radioButton) => {
      radioButton.checked = false;
      radioButton.removeAttribute('required');
    });
  }
};

const showHideRevokeConsentFollowUp = async () => {
  const radioButtons =
    revokeConsentFollowUp?.querySelectorAll<HTMLInputElement>(
      'input[type="radio"]',
    );
  if (revokeConsentCheckbox?.checked) {
    revokeConsentFollowUp?.classList.remove('d-none');
    radioButtons?.forEach((radioButton) => {
      radioButton.setAttribute('required', 'true');
    });
  } else {
    revokeConsentFollowUp?.classList.add('d-none');
    radioButtons?.forEach((radioButton) => {
      radioButton.checked = false;
      radioButton.removeAttribute('required');
    });
  }
};

showHidePersonalDataFollowUp();
showHideRevokeConsentFollowUp();

deletePersonalDataCheckbox?.addEventListener(
  'change',
  showHidePersonalDataFollowUp,
);
revokeConsentCheckbox?.addEventListener(
  'change',
  showHideRevokeConsentFollowUp,
);
